import { render, staticRenderFns } from "./GetShareholders.vue?vue&type=template&id=c291913c&scoped=true"
import script from "./GetShareholders.vue?vue&type=script&lang=js"
export * from "./GetShareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291913c",
  null
  
)

export default component.exports